<header [class.scroll]="scrollPosition >= 10">
  <div class="top-bar">
    <div class="container">
      <ion-menu-toggle class="mobile" (click)="openMenu()">
        <hr />
        <hr />
        <hr />
      </ion-menu-toggle>

      <div class="language-selector">
        <ng-container *ngIf="isVisible && availableLanguages.length > 1">
          <ion-select (ionChange)="useLanguage($event.target.value)" 
            [interfaceOptions]="languageSelectorOptions" [value]="language">
            <ion-select-option *ngFor="let language of availableLanguages" value="{{ language }}">
              {{ language }}
            </ion-select-option>
          </ion-select>
        </ng-container>
      </div>

      <ion-button [languageRouter]="['tu-negocio-aqui']" routerDirection="root" size="small" fill="clear">
        <i class="icon-briefcase"></i>
        <span>{{ 'GLOBALS.BUSINESS' | translate }}</span>
      </ion-button>

      <ion-button [languageRouter]="['como-llegar']" routerDirection="root" size="small" fill="clear">
        <i class="icon-location"></i>
        <span>{{ 'GLOBALS.DIRECTIONS' | translate }}</span>
      </ion-button>

      <ion-button [languageRouter]="['horarios']" routerDirection="root" size="small" fill="clear">
        <i class="icon-clock"></i>
        <span>{{ 'GLOBALS.SCHEDULES' | translate }}</span>
      </ion-button>
    </div>
  </div>

  <div class="bottom-bar">
    <div class="container">
      <div *ngIf="tenantLogo$ | async as tenantLogo" class="brand-logo">
        <a [languageRouter]="['home']">
          <img src="{{ tenantLogo }}" alt="" />
        </a>
      </div>
      <ion-menu-toggle (click)="openMenu()" class="desktop">
        <hr />
        <hr />
        <hr />
      </ion-menu-toggle>
    </div>
  </div>
</header>
